import 'core-js/features/object/entries';
import 'core-js/features/regexp/to-string';

import { detect } from 'detect-browser';
import { register } from './lib/views';
import { windowatch } from './lib/windowatch';
import { registerSentry } from './lib/sentry';

import 'lazysizes';
import smoothscroll from 'smoothscroll-polyfill';
import './lib/embed';

// Components
import Button from '../views/component/button/button';
import FilterSelect from '../views/component/filter-select/filter-select';
import CopyrightNotice from '../views/component/footer/copyright-notice';
import Form from '../views/component/form/form';
import FormCheckbox from '../views/component/form-checkbox/form-checkbox';
import FormField from '../views/component/form-field/form-field';
import FormFile from '../views/component/form-file/form-file';
import FormNewsletter from '../views/component/form-newsletter/form-newsletter';
import FormCountry from '../views/component/form-country/form-country';
import FormPhone from '../views/component/form-phone/form-phone';
import FormList from '../views/component/form-list/form-list';
import Hotline from '../views/component/hotline/hotline';
import Loop from '../views/component/loop/loop';
import Navigation from '../views/component/navigation/navigation';
import Overlay from '../views/component/overlay/overlay';
import Slider from '../views/component/slider/slider';
import Video from '../views/component/video/video';
import VideoHover from '../views/component/video-hover/video-hover';

// Modules
import ArticleModule from '../views/module/article/article';
import CreditsModule from '../views/module/credits/credits';
import FilterModule from '../views/module/filter/filter';
import FilterJobs from '../views/module/filter-jobs/filter-jobs';
import HistoryModule from '../views/module/history/history';
import NewsletterModule from '../views/module/newsletter/newsletter';
import FactsTickerModule from '../views/module/facts-ticker/facts-ticker';
import TeamOverviewModule from '../views/module/team-overview/team-overview';
import BookingManager from '../views/module/booking-manager/booking-manager';

// configure breakpoints
windowatch.setBreakpointSpecs({
  xs: {
    min: 0,
    max: 599,
    navigationHeight: 98,
    navigationCollapsedHeight: 98
  },
  s: {
    min: 600,
    max: 799,
    navigationHeight: 114,
    navigationCollapsedHeight: 114
  },
  m: {
    min: 800,
    max: 1199,
    navigationHeight: 114,
    navigationCollapsedHeight: 114
  },
  l: {
    min: 1200,
    max: 1599,
    navigationHeight: 156,
    navigationCollapsedHeight: 92
  },
  xl: {
    min: 1600,
    max: null,
    navigationHeight: 156,
    navigationCollapsedHeight: 92
  }
});

// Kick off the polyfills
smoothscroll.polyfill();

// Register Sentry now to detect errors
registerSentry();

// Add browser identifier class name to html tag
// makes browser sass mixin work
const browser = detect();
if (browser) {
  const $html = document.querySelector('html');
  $html.classList.add(`browser--${browser.name}-${browser.version}`);
}

function registerViews () {
  // Register component views
  register('button', Button);
  register('copyright-notice', CopyrightNotice);
  register('filter-select', FilterSelect);
  register('form-checkbox', FormCheckbox);
  register('form-field', FormField);
  register('form-file', FormFile);
  register('form-list', FormList);
  register('form-newsletter', FormNewsletter);
  register('form-country', FormCountry);
  register('form-phone', FormPhone);
  register('form', Form);
  register('hotline', Hotline);
  register('loop', Loop);
  register('navigation', Navigation);
  register('overlay', Overlay);
  register('slider', Slider);
  register('video', Video);
  register('video-hover', VideoHover);

  // Register module views
  register('module-article', ArticleModule);
  register('ufa-booking-manager', BookingManager);
  register('module-credits', CreditsModule);
  register('module-facts-ticker', FactsTickerModule);
  register('module-filter', FilterModule);
  register('module-filter-jobs', FilterJobs);
  register('module-history', HistoryModule);
  register('module-newsletter', NewsletterModule);
  register('module-team-overview__item-wrapper', TeamOverviewModule);
}

if (document.readyState !== 'loading') {
  // Dom loaded event already fired
  registerViews();
} else {
  // Wait for the dom to load
  document.addEventListener('DOMContentLoaded', registerViews);
}
